import { PAGINATE_LINK_SET } from 'constants/actionTypes';

const setPaginateLink = (nextHref, paginateType) => ({
  type: PAGINATE_LINK_SET,
  paginateType,
  nextHref,
});

export default setPaginateLink;
